// extracted by mini-css-extract-plugin
module.exports = {"link":"style-module--link--2Sc8z","scrollButtonAnchor":"style-module--scrollButtonAnchor--1pKh7"};